export default {
  en: {
    translation: {
      Title: 'Female pelvic organ prolapse (POP) therapy recommendation tool',
      Start: 'Start/Review',
      Reset: 'Reset',
      Q1: 'Vaginal bulge symptoms',
      Q2: 'Pessary',
      Q3: 'Improved',
      Q4: 'Cost matter',
      Q5: 'Sexual life',
      Q6: 'Vagina reserve',
      Q7: 'Mesh aversion',
      Q8: 'Age',
      Q9: 'Height',
      Q10: 'Weight',
      // Q12: 'Operation difficulty concern',
      Q12: 'Operation preference',
      Prior: 'Prior',
      MathPrior: 'Prior',
      UnitVector: 'Unit Vector',
      SurgeryProbability: 'Integration：Surgery probability',
      SurgeryRecommendation: 'Surgery Recommendation',
      MedicalRecords: 'Medical Records',
      R1: 'Age/BMI',
      EstimatedAgeDistribution: 'Estimated Age distribution',
      EstimatedBMIDistribution: 'Estimated BMI distribution',
      // SafetyRelated: 'Safety-related evidence review',
      SafetyRelated: 'Safety-related literature review',
      EstimatedImprovement: 'Estimated {{type}} improvement distribution',
      Yes: 'Yes',
      No: 'No',
      ForPatient: 'For Patient',
      ForPhysician: 'For Physician',
      Submit: 'Submit',
      LifeStyle: 'Life style intervention',
      PFMT: 'PFMT',
      RecommendCardTitle: 'Surgery recommendation',
      RecommendContent: `Lady Wang, 65y, BMI 19.4
      Anterior vaginal wall prolapse: stage II，uterine or vaginal vault prolapse: stage III, Posterior vaginal wall prolapse: stage II
      No cost concern, no sexual life, keep the vagina, no mesh aversion
      According to your condition and will, we recommend you the following surgical procedures.
      `,
      Rank: 'Rank',
      Procedure: 'Procedure',
      Operability: 'Operability',
      Effectiveness: 'Effectiveness',
      Safety: 'Safety',
      Economy: 'Economy',
      RecommendationProbability: 'Recommendation probability',
      Severe: 'Severe',
      recommendMsg1: 'Recommend PFMT (pelvic floor muscle training)',
      recommendMsg2: 'Keep using pessary',
      dropDownNotice: 'Drop down to see the radar chart',
      SLFFTOP: 'SSLF(sacrospinous ligament fixation） #',
      SLFF: 'SSLF(sacrospinous ligament fixation）',
      ULSTOP: 'ULS/HUS((high) uterosacral ligament suspension) *',
      ULS: 'ULS/HUS((high) uterosacral ligament suspension)',
      ATVM: 'ATVM(anterior transvaginal mesh)',
      LSC: 'SC(sacrocolpopexy)',
      PTVM: 'PTVM(posterior transvaginal mesh)',
      // LEFORT: 'Lefort(colpocleisis)',
      LEFORT: 'colpocleisis',
      NoteSLFF: '#=SSLF±vaginal wall repair±perineal body reconstruction',
      NoteULS: '*=HUS/ULS±vaginal wall repair±perineal body reconstruction',
    }
  },
  cn: {
    translation: {
      star: "*",
      well: "#",
      Title: '盆腔器官脱垂的治疗方案智能推荐平台前端系统',
      Start: '开始/回顾',
      Reset: '重置',
      Q1: '症状性脱垂',
      Q2: '试戴子宫托',
      Q3: '症状改善',
      Q4: '在意花费',
      Q5: '性生活',
      Q6: '保留阴道',
      Q7: '网片顾虑',
      Q8: '年龄',
      Q9: '身高',
      Q10: '体重',
      // Q12: '考虑手术难度',
      Q12: '操作偏好',
      // Prior: '意愿',
      Prior: '先验',
      MathPrior: '先验',
      UnitVector: '单位向量',
      SurgeryProbability: '整合：术式推荐概率',
      SurgeryRecommendation: '术式推荐',
      MedicalRecords: '电子病历',
      R1: '年龄/BMI',
      EstimatedAgeDistribution: '年龄概率分布',
      EstimatedBMIDistribution: 'BMI概率分布',
      // SafetyRelated: '安全性证据复习',
      SafetyRelated: '安全性相关文献综述',
      EstimatedImprovement: '{{type}} 改善程度概率分布',
      Yes: '是',
      No: '否',
      ForPatient: '患者',
      ForPhysician: '医生',
      Submit: '提交',
      LifeStyle: '生活方式干预',
      PFMT: '盆底肌训练',
      RecommendCardTitle: '术式推荐',
      RecommendContent: `65岁，BMI 19.4
      阴道前壁膨出II度，子宫/阴道穹窿脱垂III度，阴道后壁膨出II度
      不在意花费，无性生活，要求保留阴道，无网片顾虑
      根据您的病情与意愿，为您推荐手术方式及排序如下:`,
      Rank: '排序',
      Procedure: '术式',
      Operability: '操作倾向性',
      Effectiveness: '有效性',
      Safety: '安全性',
      Economy: '经济性',
      RecommendationProbability: '整体推荐度',
      Severe: '严重',
      recommendMsg1: '推荐生活方式干预 + 盆底肌锻炼',
      recommendMsg2: '继续使用子宫托',
      dropDownNotice: '下拉查看雷达图',
      // SLFF: 'SLFF骶棘韧带固定术/\nISFF坐骨棘筋膜固定术#',
      SLFFTOP: 'SSLF 骶棘韧带固定术 #',
      SLFF: 'SSLF 骶棘韧带固定术',
      ULSTOP: 'ULS(HUS)（高位）骶韧带悬吊术 *',
      ULS: 'ULS(HUS)（高位）骶韧带悬吊术',
      ATVM: 'ATVM 经阴道网片植入重建术（前路）',
      LSC: 'SC 骶前固定术',
      PTVM: 'PTVM 经阴道网片植入重建术（后路）',
      // LEFORT: 'Lefort阴道半封闭/阴道闭合术',
      LEFORT: 'Colpocleisis 阴道半封闭/阴道闭合术',
      // NoteSLFF: '#=SLFF/ISFF骶棘韧带/坐骨棘筋膜固定±阴道壁修补术±会阴体重建',
      NoteSLFF: '#=SSLF 骶棘韧带固定术±阴道壁修补术±会阴体重建',
      NoteULS: '*=ULS（高位）宫骶韧带悬吊±阴道壁修补±会阴体重建术'
    }
  }
};
